import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {Button, Input } from 'reactstrap';

import { onFocusChangedAsync, onValueChangedAsync, onStepChangedAsync } from './InputFocusHandlers.js'
import { styles } from "./magstim"
import * as Logging from '../utils/Logging.js'
import * as MathUtils from '../utils/MathUtils.js'

class FormControlNumber extends React.Component {

	state = {
		enabled: true
	}

	constructor() {
		super();
		this._FormControl = React.createRef();
	}

	getState(o) {
		if ((undefined === o) || (null === o)) {
			return `{${o}}`;
		}
		else {
			return `{value=${o.value} valueAsNumber=${o.valueAsNumber} min=${o.min} max=${o.max} step=${o.step} }`;
		}
	}

	logState(label) {
		//Logging.log(`${label} | ${this.props.id} | this=${this.getState(this)} | props=${this.getState(this.props)} | this._FormControl=${this.getState(this._FormControl.current)}`);
	}

	setIsEnabled(value) {
		this.setState({ enabled: value });
	}

	isEnabled() {
		return this.state.enabled;
	}

	convertNumberToText(valueAsNumber) {
		return Number(parseFloat(valueAsNumber).toPrecision(5));
	}
	
	switchToNumber() {
		if (this.valueAsNumber < this.props.min) {
			this.valueAsNumber = this.props.min;
		}
		this._FormControl.current.value = this.convertNumberToText(this.valueAsNumber);
		this._FormControl.current.type = 'number';
		this._FormControl.current.step = this.convertNumberToText(this.step);
		this._FormControl.current.min = this.min;
		this._FormControl.current.max = this.props.max;

	}

	setHighlight(value) {
		this._FormControl.current.style.background = value;
		this._FormControl.current.style.borderColor = value;
	}

	onFocus = (event) => {
		this.switchToNumber();

		if (!this.props.readonly) {
			onFocusChangedAsync(event.target, this.props.min, this.props.max, this.props.step);
		}
		else {
			onFocusChangedAsync(null);
		}
	}

	updateDisplayedText() {
		if ((undefined !== this.props.format) && (null !== this.props.format)) {
			this._FormControl.current.type = 'text';
			this._FormControl.current.value = this.props.format(this.valueAsNumber);
		}
		else {
			this.switchToNumber();
		}
	}

	// eslint-disable-next-line no-unused-vars
	onFocusOut = (event) => {
		this.logState(`FormControlNumber.onFocusOut`);
		this.updateDisplayedText();
		onFocusChangedAsync(null);
	}

	onChange = (event) => {
		this.onChangeValueImpl(event.target.value);
	}

	inputHandlerChange = (value) => {
		this.logState(`FormControlNumber.inputHandlerChange`);
		this.onChangeValueImpl(value, true);
	}

	async onChangeValueImpl(value, updateControl) {
		this.logState(`FormControlNumber.onChangeValueImpl value=${value}`);

		var newValueAsNumber = Number(value);

		if ((undefined !== this._FormControl.current.min) && (null !== this._FormControl.current.min) && (newValueAsNumber < this._FormControl.current.min)) {
			// too small...
			Logging.log(`FormControlNumber.onChangeValueImpl ${newValueAsNumber} is too small, min is ${this._FormControl.current.min} `)
			value = this._FormControl.current.min;
		}
		else if ((undefined !== this._FormControl.current.max) && (null !== this._FormControl.current.max) && (newValueAsNumber > this._FormControl.current.max)) {
			// too big...
			Logging.log(`FormControlNumber.onChangeValueImpl ${newValueAsNumber} is too big, max is ${this._FormControl.current.max} `)
			value = this._FormControl.current.max;
		}

		if (this.valueAsNumber !== value) {

			this.setValueAsNumber(value);

			onValueChangedAsync(this.valueAsNumber);

			if ((undefined !== this.props.onChange) && (null !== this.props.onChange)) {
				this.props.onChange(this.valueAsNumber);
			}

			if ((undefined !== updateControl) && (null !== updateControl) && updateControl) {
				this._FormControl.current.valueAsNumber = this.valueAsNumber; 
			}
		}
	}

	// eslint-disable-next-line no-unused-vars
	onClickPlus = (event) => {
		this.logState(`FormControlNumber.onClickPlus`);
		this.onChangeValueImpl(this.valueAsNumber + this.step);
		this.updateDisplayedText();
	}

	// eslint-disable-next-line no-unused-vars
	onClickMinus = (event) => {
		this.logState(`FormControlNumber.onClickMinus`);
		this.onChangeValueImpl(this.valueAsNumber - this.step);
		this.updateDisplayedText();
	}

	

	render() {
		this.logState(`FormControlNumber.render`);

		if (undefined === this.valueAsNumber) {
			this.valueAsNumber = this.props.defaultValue;
		}
		if (undefined === this.step) {
			this.step = this.props.step;
		}
		
		if (undefined === this.min) {
			this.min = this.props.min;
		}

		var style = styles.magstimFormControlCenter;
		if (undefined === this.props.style) {
			style = this.props.style;
		}

		var stepButtons = undefined;
		if (this.props.displayStepButtons) {
			stepButtons = <>
				<Button color="secondary" onClick={this.onClickMinus} size={this.props.size} > <i className="fas fa-minus"></i> </Button>
				<Button color="secondary" onClick={this.onClickPlus}  size={this.props.size} > <i className="fas fa-plus"></i>  </Button>
			</>;
		}

		return (
			<Wrapper>
				<div className={ 'input-group ' + this.props.displayStepButtons } >
				
				<Input 
					id={this.props.id}
					style={style}
					innerRef={this._FormControl}
					type='text'
					min={this.min}
					max={this.props.max}
					step={this.step}
					onChange={this.onChange}
					defaultValue={this.props.defaultValue}
					disabled={this.props.readonly || !this.state.enabled}
					onFocus={this.onFocus}
					onBlur={this.onFocusOut}
					bsSize={this.props.size}
					
				>
				</Input >
				{stepButtons}
				</div>
			</Wrapper>
		);
	}

	componentDidMount() {
		// Setup the change handler, so that the InputFocusHandler can call it, as changing a value programmatically doesn't fire the event... 
		this._FormControl.current.inputHandlerChange = this.inputHandlerChange;
		this.updateDisplayedText();
	}

	getValue() {
		return this._FormControl.current.value;
	}

	getValueAsNumber() {
		this.logState(`FormControlNumber.setValueAsNumber`);
		return this.valueAsNumber;
	}
	setValueAsNumber(value) {
		this.logState(`FormControlNumber.setValueAsNumber value=${value}`);
		this.valueAsNumber = MathUtils.sanitiseNum(value);
	}

	setValue(value, updateDisplayedText) {
		this.logState(`FormControlNumber.setValue value=${value} updateDisplayedText=${updateDisplayedText}`);
		this.setValueAsNumber(value);
		if ((undefined === updateDisplayedText) || updateDisplayedText) {
			this.updateDisplayedText();
		}
		else {
			this.switchToNumber();
		}
	}

	setStep(value) {
		this.logState(`FormControlNumber.setStep value=${value}`);
		this.step = Number(value);
		this._FormControl.current.step = this.step;
		if (1 === value) {
			this._FormControl.current.min = Math.floor(this.props.min);
		}
		else {
			this._FormControl.current.min = this.props.min;
		}

		onStepChangedAsync(value);
	}

	getStep() {
		this.logState(`FormControlNumber.getStep`);
		return this._FormControl.current.step;
	}

	setMin(value) {

		this.logState(`FormControlNumber.setMin value=${value}`);

		if (value < this.props.min)
		{
			value = this.props.min;
		}

		this.min = Number(value);
		this._FormControl.current.min = this.min;

		this.logState(`FormControlNumber.setMin value=${value}`);

		this.forceUpdate();
	}

	getMin() {
		this.logState(`FormControlNumber.getMin`);
		return this._FormControl.current.min;
	}

	setMax(value) {

		this.logState(`FormControlNumber.setMax value=${value}`);

		if (value > this.props.max)
		{
			value = this.props.max;
		}

		this.max = Number(value);
		this._FormControl.current.max = this.max;

		this.logState(`FormControlNumber.setMin value=${value}`);

		this.forceUpdate();
	}

	getMax() {
		this.logState(`FormControlNumber.getMax`);
		return this._FormControl.current.max;
	}
}

FormControlNumber.propTypes = {
	id: PropTypes.string,
	style: PropTypes.string,
	min: PropTypes.number,
	max: PropTypes.number,
	step: PropTypes.number,
	defaultValue: PropTypes.number,
	displayStepButtons: PropTypes.bool,
	readonly: PropTypes.bool,
	onChange: PropTypes.func,
	format: PropTypes.func,
	size: PropTypes.string
};

FormControlNumber.defaultProps = {
	id: undefined,
	style: undefined,
	min: 0,
	max: 100,
	step: 1,
	defaultValue: 5,
	displayStepButtons: false,
	readonly: false,
	onChange: undefined,
	format: undefined,
	size: "md"
};

const Wrapper = styled.div`
	.true {
		input[type=number]::-webkit-inner-spin-button,
		input[type=number]::-webkit-outer-spin-button {
			-webkit-appearance: none;
			margin: 0;
		}
	}
`;

export default FormControlNumber;